module.exports = __webpack_public_path__ + "static/media/pos_barcode_printing.d1d98c83.jpg";